import almoxarifado from './almoxarifado'
import usuarioRepository from './usuarioRepository'
import laboratorio from './laboratorio'

export default baseUrl => {
    baseUrl = `${baseUrl}/web-service`

    return {
        almoxarifado: almoxarifado(baseUrl),
        usuario: usuarioRepository(baseUrl),
        laboratorio: laboratorio(baseUrl),
    }
}
